import setHighestPriorityPackage from "./setHighestPriorityPackage"
import getAvailability from "./getAvailability"
import getPrice from "./getPrice"
import getWiypPrice from "./getWiypPrice"
import getLanguageFromLocale from "./getLanguageFromLocale"
import getSiteFromDomain from "./getSiteFromDomain"

const searchPrestationsForFilter = async (storeObj: any) => {
	const { state, commit, dispatch } = storeObj
	if (state.productUnavailable) return

	dispatch("setLoading", true)
	commit("setQuoteRequestsFinishedLoading", false)
	const avail_promise = getAvailability(
		storeObj.state.packCode,
		storeObj.state.dates.BeginDate,
		storeObj.state.dates.EndDate,
		storeObj
	)

	// fire price request asynchronously and not wait for it to finish
	if (state.packCode !== "HS" && storeObj.state.dates.BeginDate && storeObj.state.dates.EndDate) {
		await getPrice(
			storeObj.state.packCode,
			storeObj.state.dates.BeginDate,
			storeObj.state.dates.EndDate,
			storeObj
		)
	}

	if (state.packCode !== "HS" 
		&& state.dates.BeginDate 
		&& state.dates.EndDate
		&& document.cookie.split(';').some((item) => item.trim().startsWith('wiypresults2024=true'))
		&& state.prestMaps && state.prestMaps.seAvailabilities && state.prestMaps.seAvailabilities[state.packCode]
	) {
		
		const prestIds = Object.keys(state.prestMaps.seAvailabilities[state.packCode])
			.map(key => state.prestMaps.seAvailabilities[state.packCode][key].prestIdSource)
			.sort((a, b) => a - b)
			.join("-")
		
		// IN THE MEANTIME WE DO NOTHING WITH RESULTS
		const wiypPrice = await getWiypPrice(
			state.packageId,
			state.packCode,
			state.liheData.id,					
			prestIds,
			state.dates.BeginDate.split('/').reverse().join('-'),
			state.dates.EndDate.split('/').reverse().join('-'),
			state.participants.slice().sort((a: number, b: number) => b - a).join('-'),
			getSiteFromDomain(new URL(window.location.href).hostname),
			getLanguageFromLocale(state.language)
		);	
	}

	const avail_resp = await avail_promise
	dispatch("setLoading", false)

	// set more expensive package if package from url is not available
	const isPackageFromHashAvailable =
		!!avail_resp &&
		!!avail_resp.availablePackages?.find(
			(packObj: any) => packObj.codePackage === storeObj.state.packCode
		)
	if (
		avail_resp &&
		avail_resp.availablePackages &&
		!isPackageFromHashAvailable
	) {
		setHighestPriorityPackage(storeObj)
	}
}

export default searchPrestationsForFilter